import { IApplicationState } from '../../types/redux';

export function selectRegionDisplayName(state: IApplicationState) {
  return state.region?.displayName;
}
